<template>
    <div class="w-full md:w-auto">
        <div class="xl:ml-md">
            <button
                class="hidden xl:inline-block btn btn-md is-ghost"
                type="button"
                @click="$modal.show('update-addresses')"
            >
                Uppdatera adresser
            </button>
            <button
                class="list-item xl:hidden"
                type="button"
                @click="$modal.show('update-addresses')"
            >
                Uppdatera adresser
            </button>
        </div>
        <adaptive-form-modal
            name="update-addresses"
            primary-button-text="Starta import"
            primary-button-class="is-primary"
            title="Uppdatera adresser"
            :redirect-to="redirectRoute"
            :action="actionRoute"
        >
            <div>
                <div class="mb-xl p-xl bg-neutral-lightest text-sm">
                    <p>
                        Observera att filen behöver ha formatet .xslx och innehålla korrekta tabellnamn.
                    </p>
                    <span>
                        Vid inläsning av adresser kan ni uppdatera följande data:
                    </span>
                    <ul>
                        <li>HP-meter</li>
                        <li>NOD</li>
                        <li>Skåp</li>
                        <li>Tubposition</li>
                        <li>Switch/port</li>
                        <li>ODF/Kontakt</li>
                        <li>MAC-adress</li>
                        <li>Datum klar för driftsättning - anges ÅÅÅÅ-MM-DD</li>
                    </ul>
                    <p class="mt-md">
                        Övriga fält kan inte uppdateras via denna import.
                    </p>

                    <a href="/templates/imports/delivery_project_addresses.xlsx" download>
                        Ladda ned exempelfil.
                    </a>
                </div>

                <input
                    id="file"
                    type="file"
                    name="file"
                    class="hidden"
                    @change="fileSelected"
                >
                <label class="btn btn-md is-primary cursor-pointer" for="file">
                    Välj fil
                </label>

                <span class="ml-md text-sm">
                    <span v-if="file">
                        Fil har valts
                    </span>
                    <span v-else>
                        Ingen fil har valts
                    </span>
                </span>

                <div class="text-xs mt-md">
                    <span>
                        Största tillåtna filstorleken är {{ maxFileSize }}
                    </span>
                </div>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                file: null,
            };
        },
        computed: {
            actionRoute() {
                return route('admin.delivery-projects.imports.import-address-data', this.project);
            },
            redirectRoute() {
                return route('admin.delivery-projects.addresses.index', this.project);
            },
            maxFileSize() {
                return (window.App && window.App.maxFileSizeImports) ? window.App.maxFileSizeImports : '-';
            },
        },
        methods: {
            fileSelected(e) {
                this.file = e.target.value;
            },
        },
    };
</script>
